import { useCallback, useMemo, useState } from 'react';
import { Container, Card, Nav, NavItem, NavLink } from 'shards-react';
import PageTitle from '../PageTitle';
import PasswordUpdater from './components/PasswordUpdater';
import ProlifeInfo from './components/ProlifeInfo';

const EditUserProfile = () => {
  const [userInfo, setUserInfo] = useState(() => true);
  const editPassword = useMemo(() => !userInfo, [userInfo]);

  const showInfo = useCallback(() => setUserInfo(true), [setUserInfo]);
  const hideInfo = useCallback(() => setUserInfo(false), [setUserInfo]);

  return (
    <Container fluid className='main-content-container p-2'>
      <PageTitle title='benutzerprofil' subtitle='Profil bearbeiten' md='12' className='ml-sm-auto mr-sm-auto' />
      <Card>
        <Nav tabs>
          <NavItem className='m-0' onClick={showInfo}>
            <NavLink active={userInfo} tag='div' className='pointer tab-text'>
              Profile Info
            </NavLink>
          </NavItem>
          <NavItem className='m-0' onClick={hideInfo}>
            <NavLink active={editPassword} tag='div' className='pointer tab-text'>
              Passwort ändern
            </NavLink>
          </NavItem>
        </Nav>
        {userInfo && <ProlifeInfo />}
        {editPassword && <PasswordUpdater />}
      </Card>
    </Container>
  );
};

export default EditUserProfile;
